import React from "react";
import {numberWithCommas} from "../../../utils";


export default function AlignCenterText({ text, style, numberComma, children}) {
  return (
    <div style={{ textAlign: 'center', ...style }}>
      {text && (numberComma ? numberWithCommas(text) : text)}
      {children ? children : null}
    </div>
  );
}
